import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "store/user/user.slice";

function RefundPolicy({
    isAsk,
    country,
}: {
    isAsk?: boolean;
    country?: string;
}) {
    const dispatch = useDispatch();
    const myElement = document.getElementById("isAsk");

    useEffect(() => {
        if (isAsk === true) {
            myElement?.scrollIntoView({
                behavior: "smooth",
            });
        }

        if (country) dispatch(userActions.setCountry(country));
    });

    return (
        <section className="relative pb-32 pt-20 lg:px-32 w-full">
            <h1 className="text-3xl font-bold mb-6">
                Vhicasar Homes Refund Policy
            </h1>

            <p className="mb-2">
                Effective Date: <strong>July 15, 2026</strong>
            </p>

            <p className="mb-6">
                Last Updated: <strong>July 15, 2026</strong>
            </p>

            <p className="mb-6">
                At Vhicasar Homes, we strive to provide a trusted marketplace that
                connects customers with verified service providers and property
                professionals. This Refund Policy explains when refunds may be issued
                and the process for requesting one.
            </p>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    1. Marketplace Disclaimer
                </h2>

                <p>
                    Vhicasar Homes primarily acts as a technology platform that connects
                    customers with independent service providers, agents, landlords, and
                    other businesses. Unless otherwise stated, Vhicasar Homes is not the
                    direct provider of the services listed on the platform.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    2. Subscription Payments
                </h2>

                <p>
                    Vhicasar Homes offers subscription plans for service providers who wish to
                    advertise their services and access premium platform features. Subscription
                    fees are paid directly to Vhicasar Homes.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    3. Refund Eligibility
                </h2>

                <p className="mb-2">
                    Refunds may be approved under the following circumstances:
                </p>

                <ul className="list-disc list-inside ml-4">
                    <li>Duplicate or accidental subscription payments.</li>
                    <li>
                        A payment was successfully processed, but the subscription was not
                        activated due to a technical issue.
                    </li>
                    <li>
                        You were charged after cancelling automatic renewal due to a verified
                        system error.
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    4. Non-Refundable Payments
                </h2>

                <p className="mb-2">
                    Subscription payments are generally non-refundable once the subscription
                    has been activated, including:
                </p>

                <ul className="list-disc list-inside ml-4">
                    <li>You change your mind after purchasing a subscription.</li>
                    <li>You did not fully utilize your subscription period.</li>
                    <li>Your business generated fewer leads than expected.</li>
                    <li>
                        Your account was suspended or removed for violating our Terms of Service.
                    </li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    5. Subscription Cancellation
                </h2>

                <p>
                    You may cancel your subscription at any time. Cancellation prevents future
                    renewals but does not entitle you to a refund for the current billing
                    period. Your subscription benefits will remain active until the end of the
                    paid subscription period.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    6. Refund Request Process
                </h2>

                <p className="mb-2">
                    Refund requests must be submitted within <strong>7 days</strong> of the
                    payment date and should include:
                </p>

                <ul className="list-disc list-inside ml-4">
                    <li>Your registered email address.</li>
                    <li>Your payment reference or transaction ID.</li>
                    <li>A brief explanation of the issue.</li>
                </ul>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    7. Refund Processing
                </h2>

                <p>
                    If approved, refunds will be processed within 5–10 business days. The time
                    required for the funds to appear in your account depends on your payment
                    provider or financial institution.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    8. Changes to This Policy
                </h2>

                <p>
                    Vhicasar Homes reserves the right to modify this Refund Policy at any
                    time. Updated versions will be published on our website, and continued
                    use of our platform constitutes acceptance of the revised policy.
                </p>
            </section>

            <section className="mb-6">
                <h2 className="text-xl font-semibold mb-2">
                    9. Contact Us
                </h2>

                <p>
                    If you have any questions about this Refund Policy or would like to
                    request a refund, please contact us:
                </p>

                <p className="mt-2">
                    Email:{" "}
                    <a
                        href="mailto:support@vhicasar.com"
                        className="text-blue-600 underline"
                    >
                        support@vhicasar.com
                    </a>
                </p>
            </section>
        </section>
    );
}

export default RefundPolicy;